import cx from 'classnames';
import { Text } from 'platform-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import EmptyStateCircle from './stats__empty-state-circle';
import EmptyStateList from './stats__empty-state-list';

import './stats__empty-state.scss';

interface StoreProps {
    textId: string;
    mix?: string;
    values?: React.ComponentProps<typeof FormattedMessage>['values'];
}

interface Props extends StoreProps {}

export const EmptyState = React.memo(({ mix, textId, values }: Props) => {
    return (
        <div className={cx('stats__empty-state', mix)}>
            <div className="stats__empty-state-description">
                <Text id={textId} type={Text.TYPE.MARKDOWN} values={values} />
            </div>
            <div className="stats__empty-state-stub">
                <EmptyStateCircle />
                <EmptyStateList />
            </div>
        </div>
    );
});
